module.exports = __webpack_public_path__ + "img/22_12.b31dfd66.png";